import React from 'react'
import "./Navbar.css"
import {DiPython,DiNpm} from "react-icons/di"

export default function Navbar() {
    return (
        <div className="navbar">
            <a  href="https://pypi.org/user/kaankarakoc42/"><DiPython className="navbaricons"/></a>
            <a  href="https://www.npmjs.com/~kaankarakoc42/"><DiNpm className="navbaricons"/></a>
        </div>
    )
}
